import type React from 'react'
import { Label } from '~/shared/ui/label'

interface FormFieldProps {
  // biome-ignore lint/suspicious/noExplicitAny: TanStack Form field API is dynamically typed
  field: any
  label: string
  children: React.ReactNode
  optional?: boolean
  hasBlurred?: boolean
  labelAction?: React.ReactNode
}

export function FormField({
  field,
  label,
  children,
  optional,
  hasBlurred,
  labelAction,
}: FormFieldProps) {
  // Show errors only if:
  // 1. Field has been touched (user interacted with it) OR we manually tracked blur
  // 2. AND there are actual errors
  const hasInteracted = field.state.meta.isTouched || hasBlurred
  const hasErrors = field.state.meta.errors?.[0]
  const shouldShowError = hasInteracted && hasErrors

  return (
    <div className="space-y-2">
      <div className="flex items-center justify-between gap-2">
        <Label htmlFor={field.name}>
          {label}
          {optional && <span className="text-muted-foreground"> (Optional)</span>}
        </Label>
        {labelAction}
      </div>
      {children}
      {shouldShowError && (
        <p className="text-sm text-destructive">
          {typeof field.state.meta.errors[0] === 'string'
            ? field.state.meta.errors[0]
            : 'Invalid value'}
        </p>
      )}
    </div>
  )
}
